import {Link} from "react-router-dom";
import useApiUrl from "../framework/hooks/useApiUrlHook";
import {useEffect, useState} from "react";
import axios from "axios";

export default function Brands() {
    const apiUrl = useApiUrl();
    const [brands, setBrands] = useState([]);

    const getBrands = () => {
        axios
            .get(`${apiUrl}/brands/all`)
            .then((response) => {
                setBrands(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getBrands();
    }, [apiUrl]);

    return (
        <div className="brand-area sections section-b">
            <div className="brand-wrapper">
                <div className="brand-title" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                    <h2>Hier zijn wij trots op</h2>
                    <h3>Je bent in goed gezelschap</h3>
                </div>
                <div className="brand-layout">
                    {brands?.map((brand, index) => (
                        <a key={brand.id} href={`/succesverhalen/${brand.url}`} className="brand-item" data-aos="zoom-in" data-aos-delay={400+(20*index)} data-aos-duration={1000}>
                            <img
                                src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_logo_2023/orig/220/128/100/${brand.image}`}
                                alt={brand.klant}
                            />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
